import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { addBeneficiary, editBeneficiary } from 'actions/beneficiaryForm'
import BeneficiaryDisplayForm from 'views/Beneficiaries/BeneficiaryDisplayForm'
// import moment from 'moment'
import { format } from 'date-fns'
import { commonFunctions } from 'utils/CommonFunctions'
import { getEmployeeId } from 'utils/getEmployeeId'
import constants from 'constants'
import { agent } from 'utils/api'


class BeneficiaryForm extends Component {
  static propTypes = {
    beneficiaries: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object,
    hide: PropTypes.func,
    id: PropTypes.string,
    modals: PropTypes.object,
    selectedPartner: PropTypes.object,
  }
  static defaultProps = {
    hide: null,
    forms: null,
    modals: null,
    selectedPartner: null,
  }

  static defaultProps = {
    id: 'beneficiaryForm',
  }

  constructor(props) {
    super(props)
    this.state = {
      beneficiaryOptions: [],
      beneficiaryOptionLookup: {},
    }
  }

  componentDidMount() {
    this._fetchBeneficiaryOptions(this._getEmployeeId(this.props))
  }

  componentDidUpdate(prevProps) {
    const prev = this._getEmployeeId(prevProps)
    const current = this._getEmployeeId(this.props)
    if (prev !== current) {
      this._fetchBeneficiaryOptions(current)
    }
  }

  _getEmployeeId = (props) => {
    const id = getEmployeeId(props.selectedPartner, props.currentUser)
    return id || ''
  }

  _fetchBeneficiaryOptions = (employeeId) => {
    if (!employeeId) {
      this.setState({ beneficiaryOptions: [], beneficiaryOptionLookup: {} })
      return
    }
    agent.Beneficiary.listall(employeeId).then((response) => {
      const beneficiaryOptionLookup = {}
      const beneficiaryOptions = response.map((beneficiary) => {
        const mapped = {
          employeeId: beneficiary.employee_id,
          beneficiaryId: beneficiary.beneficiary_id,
          firstName: beneficiary.first_name,
          lastName: beneficiary.last_name,
          companyName: beneficiary.company_name,
          trustName: beneficiary.trust_name,
          trusteeName: beneficiary.trustee_name,
          type: beneficiary.beneficiary_type,
          dob: beneficiary.date_of_birth,
          tfn: beneficiary.tfn,
          amountType: beneficiary.beneficiary_amount_type,
          amount: beneficiary.beneficiary_amount_type
            ? commonFunctions.iff(beneficiary.beneficiary_amount_type.toLowerCase() !== 'max', beneficiary.amount_allocated, '0')
            : '0',
          effectiveDate: beneficiary.effective_date,
          address1: beneficiary.address1,
          address2: beneficiary.address2,
          suburb: beneficiary.suburb,
          city: beneficiary.city,
          state: beneficiary.state,
          postcode: beneficiary.postcode,
          country: beneficiary.country,
          year: beneficiary.year,
          fixedAmount: beneficiary.fixed_amount,
          fixedRem: beneficiary.fixed_rem,
          amountMax: beneficiary.amount_max,
          amountMin: beneficiary.amount_min,
        }
        beneficiaryOptionLookup[mapped.beneficiaryId] = mapped
        console.log(beneficiary)
        return {
          value: mapped.beneficiaryId,
          label: `${beneficiary.tfn || ''} - ${beneficiary.first_name || beneficiary.company_name || beneficiary.trust_name || ''} ${beneficiary.last_name || ''} - ${beneficiary.year || ''}`.trim(),
        }
      })
      this.setState({ beneficiaryOptions, beneficiaryOptionLookup })
    }).catch((error) => {
      console.error('Error fetching beneficiary options:', error)
      this.setState({ beneficiaryOptions: [], beneficiaryOptionLookup: {} })
    })
  }

  _submit = (data) => {    
    const formData = {
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      beneficiary_id: (data.beneficiaryId ? data.beneficiaryId : ''),
      first_name: (data.firstName ? data.firstName : ''),
      last_name: (data.lastName ? data.lastName : ''),
      company_name: (data.companyName ? data.companyName : ''),
      trust_name: (data.trustName ? data.trustName : ''),
      trustee_name: (data.trusteeName ? data.trusteeName : ''),
      beneficiary_type: (data.type ? data.type : ''),
      date_of_birth: (data.dob ? data.dob : ''),
      tfn: (data.tfn ? data.tfn : ''),
      beneficiary_amount_type: (data.amountType ? data.amountType : ''),
      amount_allocated: (data.amount ? commonFunctions.iff(data.amountType === 'max', data.amountMax, data.amount) : ''),
      // effective_date: (this.props.beneficiaries.effectiveDate ? moment(this.props.beneficiaries.effectiveDate).format('YYYY-MM-DD') : ''),
      effective_date: (this.props.beneficiaries.effectiveDate ? format(new Date(this.props.beneficiaries.effectiveDate), constants.DATE_FORMAT.STANDARD) : ''),
      address1: (data.address1 ? data.address1 : ''),
      address2: (data.address2 ? data.address2 : ''),
      suburb: (data.suburb ? data.suburb : ''),
      city: (data.city ? data.city : ''),
      state: (data.state ? data.state : ''),
      postcode: (data.postcode ? data.postcode : ''),
      country: (data.country ? data.country : ''),
      year: this.props.beneficiaries.currentFy.current.year,
      loginname: '', // loginname is stored on the webapi server session
    }
    if (data.beneficiaryId) {
      this.props.dispatch(editBeneficiary(formData, this.props.id))
    } else {
      this.props.dispatch(addBeneficiary(formData, this.props.id))
    }
  }


  render() {
    const {
      modals, hide, forms, id, beneficiaries,
    } = this.props
    const { beneficiaryOptions, beneficiaryOptionLookup } = this.state

    return (
      <BeneficiaryDisplayForm
        beneficiaries={beneficiaries}
        beneficiaryOptions={beneficiaryOptions}
        beneficiaryOptionLookup={beneficiaryOptionLookup}
        dispatch={this.props.dispatch}
        forms={forms}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        key={beneficiaries.fetched}
        modals={modals}
        title={(this.props.beneficiaries.beneficiary.beneficiaryId ? 'Update beneficiary' : 'Add beneficiary')}
        employee_id={getEmployeeId(this.props.selectedPartner, this.props.currentUser)}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  beneficiaries: state.beneficiaries,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BeneficiaryForm))



// WEBPACK FOOTER //
// ./src/containers/BeneficiaryForm.js